<template>
  <div class="row">
    <div class="col-12">
      <page-header />
      <div class="row">
        <div class="col-12 main-content">
          <div class="row">
            <div class="col-12">
              <h6 class="mb-3">
                {{ 'please_make_selection' | i18n }}
              </h6>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
              <b-form-group
                id="start-date"
                size="sm"
                :label="'date_range' | i18n"
                label-for="start-date-input"
              >
                <date-range-picker
                  v-model="dateRange"
                  opens="right"
                  :show-dropdowns="true"
                  :locale-data="languages[lng]"
                  :auto-apply="true"
                  @update="updateValues"
                >
                  <template
                    #input="picker"
                    style="min-width: 350px;"
                  >
                    {{ picker.startDate | date }} - {{ picker.endDate | date }}
                  </template>
                </date-range-picker>
              </b-form-group>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <b-form-group
                id="order-origin"
                size="sm"
                :label="'order_origin' | i18n"
                label-for="order-origin-input"
              >
                <b-form-input
                  id="order-origin-input"
                  v-model="formData.orderOrigin"
                  type="text"
                  size="sm"
                />
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <b-button
                class="mr-3 mb-3 button-total"
                size="sm"
                variant="primary"
                @click="openStatistics('sales')"
              >
                {{ 'sales' | i18n }}
                <div class="button-total-value">
                  {{ stats.assignments }}
                </div>
              </b-button>
              <b-button
                class="mr-3 mb-3 button-total"
                size="sm"
                variant="primary"
                @click="openStatistics('hitList', 'totalValue')"
              >
                {{ 'hit_list_by_sales' | i18n }}
                <div class="button-total-value">
                  {{ stats.artikel }}
                </div>
              </b-button>
              <b-button
                class="mr-3 mb-3 button-total"
                size="sm"
                variant="primary"
                @click="openStatistics('hitList', 'numberOfOrders')"
              >
                {{ 'hit_list_by_number_of_orders' | i18n }}
                <div class="button-total-value">
                  {{ stats.artikel }}
                </div>
              </b-button>
              <b-button
                class="mr-3 mb-3 button-total"
                size="sm"
                variant="primary"
                @click="openStatistics('operations')"
              >
                {{ 'operations' | i18n }}
                <div class="button-total-value">
                  {{ stats.kunden }}
                </div>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import 'moment/locale/de';
import 'moment/locale/en-gb';
import {StatisticsMixin} from '../../mixins';

import DateRangePicker from 'vue2-daterange-picker';
import {de, en} from 'vuejs-datepicker/dist/locale';
import appConfig from '../../app.config';
import calendarIcon from '../../assets/icons/calendar.svg';
import PageHeader from '../structure/page-header';

export default {
  name: 'Statistics',
  components: {PageHeader, DateRangePicker},
  filters: {
    date: function (value) {
      if (!value) return '';
      return moment(value).format('MMMM DD, YYYY');
    }
  },
  mixins:[StatisticsMixin],
  data: function () {
    return {
      dateRange:{
        startDate: null,
        endDate: null
      },
      stats:{
        artikel: 0,
        assignments: 0,
        kunden: 0,
      },
      languages: {
        de : {
          daysOfWeek : de._days,
          monthNames : de._months,
        },
        en : {
          daysOfWeek : en._days,
          monthNames : en._months,
        }
      },
      calendarIcon,
      formData: {
        orderOrigin: null
      },
      statisticsUrls: {
        sales: 'Umsaetze',
        operations: 'Vorgaenge',
        hitList: 'Artikelhitliste'
      }
    };
  },
  created() {
    moment.locale(this.lng);
  },
  methods: {
    openCalendar(ref) {
      this.$refs[ref].showCalendar();
    },
    getBaseParams() {
      const startDateTimestamp = this.dateRange.startDate ? moment(this.dateRange.startDate).unix() : '0';
      const endDateTimestamp = this.dateRange.endDate ? moment(this.dateRange.endDate).unix() : moment().unix();
      return {startDateTimestamp, endDateTimestamp};
    },
    async updateValues() {
      const {startDateTimestamp, endDateTimestamp} = this.getBaseParams();
      const response = await this.statisticsService.getTotal({StartDate :startDateTimestamp, EndDate: endDateTimestamp });
      this.stats = response;
    },
    openStatistics(statisticsType, sortRule) {
      const {startDateTimestamp, endDateTimestamp} = this.getBaseParams();
      let url = `${appConfig.apiUrl}/Statistik/${this.statisticsUrls[statisticsType]}?StartDate=${startDateTimestamp}&EndDate=${endDateTimestamp}`;
      if (statisticsType === 'hitList' && sortRule) {
        url = this.addSortRule(url, sortRule);
      }

      if (this.formData.orderOrigin) {
        url = this.addOrderOrigin(url);
      }

      window.open(url, '_blank');
    },
    addOrderOrigin(url) {
      url += `&orderOrigin=${this.formData.orderOrigin}`;
      return url;
    },
    addSortRule(url, sortRule) {
      url += `&SortRule=${sortRule}`;
      return url;
    }
  }
};
</script>

<style scoped lang="scss">
  ::v-deep   .main-content {
    overflow: visible;
  }

  ::v-deep   .rp-datepicker {
    flex-grow: 1.2;
    flex-basis: 0%;

    .form-control:disabled, .form-control[readonly] {
      background-color: #ffffff;
    }
  }

  ::v-deep   .input-group-append button {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
  }

  .vue-daterange-picker{
    width: 100%;
  }

  ::v-deep   .vue-daterange-picker .form-control{
    height: 31px !important;
    padding-top: 4px;
    border-radius: 0.2rem;
    border: 1px solid #ced4da;
  }

  ::v-deep   .daterangepicker{
    top: 35px;
  }

  ::v-deep   .monthselect{
    width: 91px !important;
  }

  .button-total{
    position: relative;
  }
  
  .button-total-value{
    position: absolute;
    right: -15px;
    top: -15px;
    color: white;
    width: 30px;
    height: 30px;
    border: 3px solid white;
    border-radius: 50%;
    background: #2260FF;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 5px;
    font-size: 11px;
  }
</style>
